/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconApps from '../../../../../../Icon/IconApps';
import IconArrowBack from '../../../../../../Icon/IconArrowBack';
import IconArrowDownward from '../../../../../../Icon/IconArrowDownward';
import IconArrowDropDown from '../../../../../../Icon/IconArrowDropDown';
import IconArrowDropDownCircle from '../../../../../../Icon/IconArrowDropDownCircle';
import IconArrowDropUp from '../../../../../../Icon/IconArrowDropUp';
import IconArrowForward from '../../../../../../Icon/IconArrowForward';
import IconArrowUpward from '../../../../../../Icon/IconArrowUpward';
import IconCancel from '../../../../../../Icon/IconCancel';
import IconCheck from '../../../../../../Icon/IconCheck';
import IconChevronLeft from '../../../../../../Icon/IconChevronLeft';
import IconChevronRight from '../../../../../../Icon/IconChevronRight';
import IconClose from '../../../../../../Icon/IconClose';
import IconExpandLess from '../../../../../../Icon/IconExpandLess';
import IconExpandMore from '../../../../../../Icon/IconExpandMore';
import IconFirstPage from '../../../../../../Icon/IconFirstPage';
import IconFullscreen from '../../../../../../Icon/IconFullscreen';
import IconFullscreenExit from '../../../../../../Icon/IconFullscreenExit';
import IconLastPage from '../../../../../../Icon/IconLastPage';
import IconMenu from '../../../../../../Icon/IconMenu';
import IconMoreHoriz from '../../../../../../Icon/IconMoreHoriz';
import IconMoreVert from '../../../../../../Icon/IconMoreVert';
import IconRefresh from '../../../../../../Icon/IconRefresh';
import IconSubdirectoryArrowLeft from '../../../../../../Icon/IconSubdirectoryArrowLeft';
import IconSubdirectoryArrowRight from '../../../../../../Icon/IconSubdirectoryArrowRight';
import IconUnfoldLess from '../../../../../../Icon/IconUnfoldLess';
import IconUnfoldMore from '../../../../../../Icon/IconUnfoldMore';

export default function NavigationIcons() {
  return (
    <div>
      <CategoryHeader>navigation</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconApps size="32"/>
          <FigCaption>
            IconApps
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowBack size="32"/>
          <FigCaption>
            IconArrowBack
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowDownward size="32"/>
          <FigCaption>
            IconArrowDownward
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowDropDown size="32"/>
          <FigCaption>
            IconArrowDropDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowDropDownCircle size="32"/>
          <FigCaption>
            IconArrowDropDownCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowDropUp size="32"/>
          <FigCaption>
            IconArrowDropUp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowForward size="32"/>
          <FigCaption>
            IconArrowForward
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArrowUpward size="32"/>
          <FigCaption>
            IconArrowUpward
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCancel size="32"/>
          <FigCaption>
            IconCancel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCheck size="32"/>
          <FigCaption>
            IconCheck
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChevronLeft size="32"/>
          <FigCaption>
            IconChevronLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChevronRight size="32"/>
          <FigCaption>
            IconChevronRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconClose size="32"/>
          <FigCaption>
            IconClose
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExpandLess size="32"/>
          <FigCaption>
            IconExpandLess
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExpandMore size="32"/>
          <FigCaption>
            IconExpandMore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFirstPage size="32"/>
          <FigCaption>
            IconFirstPage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFullscreen size="32"/>
          <FigCaption>
            IconFullscreen
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFullscreenExit size="32"/>
          <FigCaption>
            IconFullscreenExit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLastPage size="32"/>
          <FigCaption>
            IconLastPage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMenu size="32"/>
          <FigCaption>
            IconMenu
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMoreHoriz size="32"/>
          <FigCaption>
            IconMoreHoriz
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMoreVert size="32"/>
          <FigCaption>
            IconMoreVert
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRefresh size="32"/>
          <FigCaption>
            IconRefresh
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubdirectoryArrowLeft size="32"/>
          <FigCaption>
            IconSubdirectoryArrowLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubdirectoryArrowRight size="32"/>
          <FigCaption>
            IconSubdirectoryArrowRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUnfoldLess size="32"/>
          <FigCaption>
            IconUnfoldLess
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUnfoldMore size="32"/>
          <FigCaption>
            IconUnfoldMore
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/NavigationIcons.js